'use client';

import { Menu } from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';

type MenuButtonProps = {
  onClick: () => void;
  className?: string;
  isVisible?: boolean;
};

export const MenuButton = ({ onClick, className, isVisible = true }: MenuButtonProps) => {
  return (
    <div
      className={cn(
        'mt-px transition-[width,margin] duration-300 ease-in-out',
        isVisible ? 'w-6' : 'w-0',
      )}
    >
      <button
        onClick={onClick}
        aria-label='Open menu'
        className={cn(
          'transition-opacity duration-300 ease-in-out',
          !isVisible ? 'opacity-0' : 'opacity-100',
          className,
        )}
      >
        <Menu size={28} />
      </button>
    </div>
  );
};
